import axios from '@/libs/api.request'
export const getCont = (params) => {
  return axios.request({
    url: '/common/contraband',
    method: 'GET',
    params
  })
}
export const getDetails = (id) => {
  return axios.request({
    url: `/common/contraband/${id}`,
    method: 'GET'
  })
}
export const del = (id) => {
  return axios.request({
    url: `/common/contraband/${id}`,
    method: 'DELETE'
  })
}
export const update = (data) => {
  return axios.request({
    url: `/common/contraband/${data.id}`,
    method: 'PUT',
    data
  })
}
export const add = (data) => {
  return axios.request({
    url: '/common/contraband',
    method: 'POST',
    data
  })
}
